import React from "react";
import { Outlet } from "react-router-dom";
import Header from "../components/Header";
import Sidebar from "../components/Sidebar";

const AuthenticatedLayout: React.FC = () => {
  const containerStyle: React.CSSProperties = {
    display: "flex",
    minHeight: "calc(100vh - 56px)",
  };

  const mainStyle: React.CSSProperties = {
    flex: 1,
  };

  return (
    <>
      <div style={containerStyle}>
        <Sidebar />
        <main style={mainStyle}>
          <Header />
          <Outlet />
        </main>
      </div>
    </>
  );
};

export default AuthenticatedLayout;
